import { Pipe, PipeTransform } from '@angular/core';
import { CardSize } from 'qp-ui-interface';

const ImageSize = {
  LARGE: 413,
  REGULAR: 305,
  XLARGE: 1280,
  DEFAULT: 240,
};

@Pipe({
  name: 'size',
})
export class SizePipe implements PipeTransform {
  transform(cardSize: CardSize, type?: string): number | string {
    let size: number;

    switch (cardSize) {
      case 'large':
        size = ImageSize.LARGE;
        break;
      case 'regular':
        size = ImageSize.REGULAR;
        break;
      case 'xlarge':
        size = ImageSize.XLARGE;
        break;
      default:
        size = ImageSize.DEFAULT;
        break;
    }

    return type === 'string' ? size + 'px' : size;
  }
}
